import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcesses(organization_id) {
    return RequesterV1.get(
      "open_queries/organization/basic_production/process/" + organization_id
    );
  }
};
